export const NAME = 'search';


/** WEBPACK FOOTER **
 ** ./src/modules/search/constants.js
 **/